<template>
  <d2-container>
    <template slot="header">
      <el-input
        clearable
        @keyup.enter.native="getSearch"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入用户id"
        size="small"
        v-model="listQuery.accountId"
      ></el-input>
      <el-select
        clearable
        class="filter-item"
        v-model="listQuery.appointId"
        placeholder="请选择委托"
        style="margin-right: 20px;"
      >
        <el-option
          v-for="getCR in getCRsList"
          :key="getCR.id"
          :label="getCR.name"
          :value="getCR.id"
        ></el-option>
      </el-select>
      <el-select
        clearable
        filterable
        class="filter-item"
        v-model="listQuery.themeId"
        placeholder="请选择打卡任务"
        style="margin-right: 20px;"
      >
        <el-option
          v-for="getCR in getsThemeList"
          :key="getCR.id"
          :label="getCR.title"
          :value="getCR.id"
        ></el-option>
      </el-select>
      <el-select
        @keyup.enter.native="getSearch"
        v-model="listQuery.status"
        clearable
        placeholder="请选择状态"
        size="small"
        style="margin-top:5px;margin-right: 20px;"
      >
        <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button @click="getSearch" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="entrustRecordList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户昵称">
        <template slot-scope="scope">
          <span>{{ scope.row.nickName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="委托标题">
        <template slot-scope="scope">
          <span>{{ scope.row.appointTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="委托id">
        <template slot-scope="scope">
          <span>{{ scope.row.appointId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="任务标题">
        <template slot-scope="scope">
          <span>{{ scope.row.themeTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="任务id">
        <template slot-scope="scope">
          <span>{{ scope.row.themeId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="奖品名称">
        <template slot-scope="scope">
          <span>{{ scope.row.giftName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="奖品id">
        <template slot-scope="scope">
          <span>{{ scope.row.giftId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="获得时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">未领取</span>
          <span v-if="scope.row.status == 1">已领取</span>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import { getThemeList } from '@/api/demo/punchInActivity/index'
import { getLogList, getCRList } from '@/api/demo/CommissionRelate/index'
export default {
  name: 'entrustRecordManger',
  data () {
    return {
      listQuery: {
        accountId: '',
        appointId: '',
        currentPage: 1,
        pageSize: 20,
        status: '',
        themeId: ''
      },
      statusList: [
        {
          name: '未领取',
          id: 0
        },
        { name: '已领取', id: 1 }
      ],
      listLoading: true, // 加载圈圈
      entrustRecordList: [],
      getsThemeList: [],
      getCRsList: [],
      tableKey: 0,
      total: null
    }
  },
  created () {
    this.getSearch()
    this.getThemesList()
    this.getCRList()
  },
  methods: {
    getSearch () {
      let that = this
      getLogList(that.listQuery).then(res => {
        that.listLoading = true
        that.entrustRecordList = res.records
        that.total = parseInt(res.total)
        that.listLoading = false
      })
    },
    // 获取打卡任务
    getThemesList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 2000,
        classifyId: null,
        keyword: null,
        status: 1
      }
      getThemeList(listQuery).then(res => {
        that.getsThemeList = res.records
      })
    },
    getCRList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200, // 每页显示的大小
        status: 1
      }
      getCRList(listQuery).then(res => {
        that.getCRsList = res.records
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    }
  }
}
</script>
<style scoped>
</style>
